import { Component, HostListener } from '@angular/core';

@Component({
    selector: 'nuso-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'quoting';

  constructor() {
  }
}
